var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.fetchingJob && _vm.job)?_c('div',[_c('create-job',{attrs:{"clone":_vm.job}})],1):_c('loading-page')}
var staticRenderFns = []

export { render, staticRenderFns }